<template>
  <div class="profile rj-content">

    <div class="profile rj-content se">
      <h1>Mis consultas</h1>
      <p class="main-description">Agenda una consulta conmigo y analizaremos tu carta astral durante una sesión presencial
        o virtual, en la que te ayudaré a definir las acciones futuras adecuadas para alcanzar el éxito.</p>
      <v-card color="#ECEFF1">
        <v-card-subtitle class="text-h5 font-weight-bold">Datos de la consulta</v-card-subtitle>
        <v-card-text class="text-body-1">
          <p>Fecha: 24/08/2020</p>
          <p>Motivo: Consulta sobre nuevo negocio</p>
          <p>Medio de pago: Tarjeta de crédito/débito</p>
          <p>Estado: Confirmado</p>
        </v-card-text>
      </v-card>

      <strong><p class="mt-7">Si tienes alguna duda o comentario comunicate con nosotros a contacto@rubenjungbluth.com</p></strong>

      <v-btn outlined color="indigo" small>Imprimir</v-btn>
      <v-btn class="ma-5" outlined color="indigo" small>Regresar a consulta personal</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PayConsultation2'
}
</script>
<style lang="scss" scoped>
.profile {
  width: 100%;

  ::v-deep .v-expansion-panel {
    border-bottom: 1px solid #DEE3E6;
    margin-top: 0;

    > button {
      padding: 20px 8px 18px 8px;
      min-height: auto;
    }

    .v-expansion-panel-header {
      font-weight: 800;
      color: #656565;
      font-size: 20px;

      .v-expansion-panel-header__icon {
        margin-left: 8px;

        .v-icon {
          color: #B3B3B3 !important;
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 0 10px 16px;
    }
  }
}

.details {
  font-size: 12px;
  font-weight: 200;
}

.ctn-btn {
  font-weight: 200;
  margin-top: 20px;

  ::v-deep .v-btn {
    background-color: #2C8886;
  }

  label {
    margin-left: 12px;
    vertical-align: middle;
    font-weight: 200;
  }
}

.save-btn {
  margin: 35px 0 20px;
  text-transform: none;
  font-size: 14px;
  width: 160px;
  border-radius: 7px;
  height: 40px;
}


.phone-dial, .phone-value {
  display: inline-block;
  vertical-align: bottom;
}

</style>
